import React from "react";

import { templates } from "@reactivated";

import { ProductGridSSR } from "../apps/product-grid2/ProductGridSSR";

export const Template = (
    props: templates.ProductGridBlockTemplate,
): React.JSX.Element => {
    return <ProductGridSSR {...props} />;
};
